<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitleab"><a id="page_xxix">W<span class="small">HERE</span> R<span class="small">IVERS AND</span> M<span class="small">OUNTAINS</span> S<span class="small">ING</span></a></p><a id="page_xxix">
<div class="image"><img alt="Image" src="images/cmn.png"/></div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 12_FM04.vue?7a9f7f6d